import React, { Component } from 'react';
// import PropTypes from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import TableList from '../../components/TableList';
import { ContextMenu } from 'components/context-menu/context-menu';
import { MessengerBox } from 'components/messenger-box/messenger-box';
import { CheckBox } from 'components/checkboxes/check-box';
import { Popup } from 'components/Popup/popup';
import * as UnitHelper from 'helper/unit-helper';
import * as ItemRepairActionType from '../constants';
import * as TradeActionType from 'Trades/constants';
import { AddEditItemModal } from '../Components/add-edit-item-modal';
// import 'css/tooltip.css';
import { SearchBox } from 'components/searchbox/index';

const defaultParams = {
  defaultSortName: 'tradeName',
  defaultSortOrder: 'ascending',
  sizePerPage: 10
};

const TABLE_NAME = 'ITEM_TO_REPAIR_LIST';

class ManageItemRepairs extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    location: PropTypes.object,
    ItemRepairStore: PropTypes.object,
    PageSizeReference: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.sizePerPage = UnitHelper.initialSizePerPage(
      TABLE_NAME,
      props.PageSizeReference,
      props.ItemRepairStore.ManageItemRepair.params.take
    );

    const tradeNameSearch = this.props.location.state
      ? props.location.state.tradeName
      : '';
    this.state = {
      defaultSortName: defaultParams.defaultSortName, // default sort column name
      defaultSortOrder: defaultParams.defaultSortOrder, // default sort order,
      currentPage: props.ItemRepairStore.ManageItemRepair.params.skip,
      sizePerPage: this.sizePerPage,
      totalRecord: props.ItemRepairStore.ManageItemRepair.params.totalRecord,
      data: props.ItemRepairStore.ManageItemRepair.items,
      status: props.ItemRepairStore.ManageItemRepair.params.status,
      tradeNameSearch: tradeNameSearch,
      isOpenModal: false,
      isShowPopup: false,
      checkedValues: ['active', 'inActive']
    };
  }

  componentDidMount() {
    this.binding({
      ...this.objToParams(this.props.ItemRepairStore.ManageItemRepair.params),
      take: this.state.sizePerPage
    });

    const self = this;
    window.addEventListener('click', e => {
      if (
        document.getElementById('s1-popup') &&
        document.getElementById('s1-popup').contains(e.target)
      ) {
        // Clicked in box
      } else {
        // Clicked outside the box
        if (
          document.getElementById('popup-button') &&
          document.getElementById('popup-button').contains(e.target)
        ) {
          // clicked in box
        } else {
          if (self.state.isShowPopup) {
            self.setState({ isShowPopup: false });
          }
        }
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    // this.setState({
    //   isOpenModal: nextProps.IsOpenFormAddEdit
    // });
    const {
      ItemRepairStore: { ManageItemRepair }
    } = nextProps;
    if (ManageItemRepair) {
      this.setState({
        totalRecord: ManageItemRepair.params.totalRecord,
        data: ManageItemRepair.items,
        status: ManageItemRepair.params.status,
        currentPage: ManageItemRepair.params.skip
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.sizePerPage !== this.state.sizePerPage) {
      UnitHelper.dispatchActionSetPageSizeReference(
        this.props.dispatch,
        TABLE_NAME,
        this.state.sizePerPage
      );
    }
  }

  componentWillUnmount() {
    this.props.dispatch({ type: ItemRepairActionType.RESET_ITEM_REPAIR });
  }

  customRenderName(item) {
    var style = {};

    if (!item.status) {
      style = { opacity: 0.5 };
    }

    return <span style={style}>{item.description}</span>;
  }

  customRenderProblems(item) {
    if (!item.status) {
      let style = { opacity: 0.5 };
      return <span style={style}>{item.problemCount}</span>;
    }

    return (
      <span>
        <Link
          to={{
            pathname: '/items/problems/' + item.id,
            state: { itemToRepair: item }
          }}
        >
          {item.problemCount}
        </Link>
      </span>
    );
  }

  customRenderTrade(item) {
    var style = {};

    if (!item.status) {
      style = { opacity: 0.5 };
    }

    return <span style={style}>{item.tradeName}</span>;
  }

  customRenderBtnAction(item) {
    return (
      <a
        className='glyphicon glyphicon-option-vertical cls-table-black-icon'
        onClick={e => {
          this.onContextMenu(e, item);
        }}
      />
    );
  }

  binding(params) {
    this.props.dispatch({
      type: ItemRepairActionType.SEARCH_ITEM_REPAIR_ASYNC,
      params: params
    });
  }

  onContextMenu(e, item) {
    var contextItem = [];

    if (item.status) {
      contextItem = [
        {
          title: 'Edit',
          icon: 'glyphicon glyphicon-pencil',
          event: this.onOpenAddEditPopup.bind(this)
        },
        {
          title: 'Make inactive',
          icon: 'glyphicon glyphicon-minus-sign',
          event: this.onMakeInActive.bind(this)
        }
      ];
    } else {
      contextItem = [
        {
          title: 'Edit',
          icon: 'glyphicon glyphicon-pencil',
          event: this.onOpenAddEditPopup.bind(this)
        },
        {
          title: 'Make active',
          icon: 'glyphicon glyphicon-ok-sign',
          event: this.onMakeActive.bind(this)
        }
      ];
    }

    this.cxtMenu.state.event(e, item, contextItem);
  }

  onMakeInActive(e, item) {
    this.msgBox.confirm(
      null,
      'All of item name\'s associated problems are going to be also deactivated. Continue ?',
      () => {
        this.onSaveItem(
          e,
          item.id,
          ItemRepairActionType.MAKE_INACTIVE_ITEM_REPAIR_ASYNC
        );
      }
    );
  }

  onMakeActive(e, item) {
    this.onSaveItem(
      e,
      item.id,
      ItemRepairActionType.MAKE_ACTIVE_ITEM_REPAIR_ASYNC
    );
  }

  onTableBinding(configTable) {
    var params = this.objToParams(
      this.props.ItemRepairStore.ManageItemRepair.params
    );
    this.binding({
      ...params,
      sortField: configTable.sort.field,
      sortOrder: configTable.sort.order,
      skip: configTable.page.skip - 1,
      take: configTable.page.take
    });
  }

  onSearch = () => {
    var params = this.objToParams(
      this.props.ItemRepairStore.ManageItemRepair.params
    );
    this.setState({
      checkedValues: ['active', 'inActive']
    });

    this.binding({
      ...params,
      status: 'all',
      skip: 0
    });
  };

  onEnter(e) {
    if (e.key === 'Enter') {
      this.onSearch(e);
    }
  }

  onSaveItem(e, data, itemRepairActionType) {
    var params = {
      ...this.objToParams(this.props.ItemRepairStore.ManageItemRepair.params),
      description: this.searchBox.state.value
    };
    this.props.dispatch({
      type: itemRepairActionType,
      params: {
        data: data,
        search: params
      },
      callback: () => {
        this.setState({
          isOpenModal: false
        });
      }
    });
  }

  onOpenAddEditPopup(e, item) {
    if (typeof item === 'undefined') {
      this.props.dispatch({
        type: ItemRepairActionType.OPEN_FORM_CREATE_ITEM_REPAIR,
        params: null
      });
    } else {
      this.props.dispatch({
        type: ItemRepairActionType.GET_ITEM_REPAIR_BY_ID_SUCCESS,
        data: item
      });
    }
    this.setState({ isOpenModal: true });
  }

  onFetchTrade = () => {
    this.props.dispatch({
      type: TradeActionType.SELECT_LIST_TRADE_ASYNC,
      params: {
        searchKey: '',
        selectedValue: '',
        setDefaultSelected: false
      }
    });
  };

  closeModal = e => {
    e.preventDefault();
    this.setState({
      isOpenModal: false
    });
  };

  handleChange = (e, value) => {
    if (this.state.checkedValues.includes(value)) {
      this.setState(
        {
          checkedValues: [
            ...this.state.checkedValues.filter(item => item !== value).sort()
          ]
        },
        () => {
          this.onChecked(e, this.state.checkedValues);
        }
      );
    } else {
      this.setState(
        {
          checkedValues: [...this.state.checkedValues, value].sort()
        },
        () => {
          this.onChecked(e, this.state.checkedValues);
        }
      );
    }
  };

  onTogglePopupFilter = () => {
    this.setState({
      isShowPopup: !this.state.isShowPopup
    });
  };

  onChecked(e, data) {
    var status = UnitHelper.isEmpty(data.toString()) ? '' : data.toString();
    if (status !== '') {
      var params = this.objToParams(
        this.props.ItemRepairStore.ManageItemRepair.params
      );
      if (status.includes('active,inActive')) {
        status = 'all';
      }
      this.binding({
        ...params,
        status: status,
        skip: 0
      });
    } else {
      this.setState({ data: [] });
    }
  }

  objToParams(obj) {
    let value = this.state.tradeNameSearch
      ? this.state.tradeNameSearch
      : this.searchBox.state.value;

    return {
      searchKey: value,
      searchField: this.state.tradeNameSearch ? 'tradeName' : '',
      sortField: obj.sort.field,
      sortOrder: obj.sort.order,
      status: obj.status,
      skip: obj.skip - 1,
      take: obj.take
    };
  }

  onChangeInput = data => {
    this.setState({
      tradeNameSearch: data
    });
  };

  refreshList(params) {
    this.setState(
      {
        defaultSortName: params.defaultSortName,
        defaultSortOrder: params.defaultSortOrder,
        sizePerPage: params.sizePerPage
      },
      () => {
        this.props.dispatch({
          type: ItemRepairActionType.SEARCH_ITEM_REPAIR_ASYNC,
          params: {
            searchKey: this.searchBox.state.value,
            sortField: params.defaultSortName,
            sortOrder: params.defaultSortOrder,
            status: this.state.status,
            skip: params.currentPage - 1,
            take: params.sizePerPage
          }
        });
      }
    );
  }

  render() {
    const column = [
      {
        field: 'id',
        header: 'id',
        hidden: true,
        isKey: true,
        sort: false,
        dataAlign: 'left',
        headerAlign: 'left'
      },
      {
        field: 'description',
        header: 'Name',
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: 'left',
        headerAlign: 'left',
        customRender: this.customRenderName.bind(this)
      },
      {
        field: 'problemCount',
        header: 'Problems',
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: 'left',
        headerAlign: 'left',
        customRender: this.customRenderProblems.bind(this)
      },
      {
        field: 'tradeName',
        header: 'Trade',
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: 'left',
        headerAlign: 'left',
        customRender: this.customRenderTrade.bind(this)
      },
      {
        field: '',
        header: '',
        hidden: false,
        isKey: false,
        sort: false,
        dataAlign: 'right',
        headerAlign: 'right',
        customRender: this.customRenderBtnAction.bind(this),
        className: 'column-action',
        columnClassName: 'column-action'
      }
    ];

    const { data } = this.state;

    const totalRecord = data.length > 0 ? this.state.totalRecord : 0;

    const options = {
      defaultSortName: this.state.defaultSortName, // default sort column name
      defaultSortOrder: this.state.defaultSortOrder, // default sort order,
      sizePerPage: this.state.sizePerPage,
      totalRecord: totalRecord
    };

    const customHeader = (
      <div className='table-header'>
        <Row>
          <Col sm={12} md={12} className='text-right'>
            <div className='box-search'>
              <SearchBox
                ref={ref => {
                  this.searchBox = ref;
                }}
                txtSearch={this.state.tradeNameSearch}
                placeholder='item to repair/trade'
                onSearch={this.onSearch}
                onChangeInput={this.onChangeInput}
              />
            </div>

            <div className='manage-user-filter pull-right'>
              <button
                onClick={this.onTogglePopupFilter}
                className='btn btn-secondary fa fa-filter btn-icon'
                id='popup-button'
              />

              {this.state.isShowPopup && (
                <Popup
                  ref={ref => {
                    this.popup = ref;
                  }}
                >
                  <CheckBox
                    checked={this.state.checkedValues.includes('active')}
                    onChecked={this.onChecked.bind(this)}
                    name='isActive'
                    className='checkbox-default'
                    value='active'
                    label='Active'
                    handleChange={this.handleChange}
                  />
                  <CheckBox
                    checked={this.state.checkedValues.includes('inActive')}
                    onChecked={this.onChecked.bind(this)}
                    name='isActive'
                    className='checkbox-default'
                    value='inActive'
                    label='InActive'
                    handleChange={this.handleChange}
                  />
                </Popup>
              )}
            </div>
          </Col>
        </Row>
      </div>
    );

    return (
      <div id='manage-user'>
        <div className='page-title clearfix'>
          <h2 className='pull-left'>Items to repair ({totalRecord})</h2>
          <button
            className='btn btn-primary btn-info btn-siteone pull-right btn-icon'
            onClick={this.onOpenAddEditPopup.bind(this)}
          >
            <span className='fa fa-plus icon' />
            NEW
          </button>
        </div>

        {this.state.isOpenModal && (
          <AddEditItemModal
            isOpen={this.state.isOpenModal}
            item={this.props.ItemRepairStore.ItemRepairProfile}
            selectListItemTrades={
              this.props.ItemRepairStore.SelectListItemTrades
            }
            errorMsg={this.props.ItemRepairStore.ErrorMsg}
            isCreate={this.props.ItemRepairStore.IsCreate}
            title={this.props.ItemRepairStore.Title}
            onFetchTrade={this.onFetchTrade}
            closeModal={this.closeModal}
            onSubmit={this.onSaveItem.bind(this)}
          />
        )}

        <TableList
          ref={ref => {
            this.tableList = ref;
          }}
          column={column}
          defaultParams={defaultParams}
          data={data}
          options={options}
          refreshPageList={this.refreshList.bind(this)}
          refreshList={this.refreshList.bind(this)}
          showButtonMenu={true}
          onContextMenu={this.onContextMenu.bind(this)}
          customTableHeader={customHeader}
        />

        <ContextMenu
          ref={ref => {
            this.cxtMenu = ref;
          }}
        />
        <MessengerBox
          ref={ref => {
            this.msgBox = ref;
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    ItemRepairStore: state.ItemRepairStore,
    PageSizeReference: state.BuilderStore.PageSizeReference
  };
};

export default connect(mapStateToProps)(ManageItemRepairs);



// WEBPACK FOOTER //
// ./src/Items/Containers/manage-item-repair.js